<template>
  <div class="owal-alerts__timeline-wrapper" :class="hasSingleAlertSource ? 'full-width' : 'split'">
    <virtual-list
      v-if="hasVisibleEvents"
      :size="this.size"
      :remain="this.remain"
      wtag="ul"
      infinite-wrapper
      class="infinite-wrapper"
      :class="hasSingleAlertSource ? 'full-width' : 'split'"
    >
      <day-collection
        v-for="(alerts, date) in eventsByDay"
        :key="date"
        :date="date"
        :events="alerts"
      />
      <infinite-loading
        ref="infinite"
        :force-use-infinite-wrapper="true"
        @infinite="loadNewEvents"
      >
        <owal-spinner-banner slot="spinner" />
      </infinite-loading>
    </virtual-list>
    <div
      v-else
      class="owal-alerts__empty-results-wrapper"
    >
      <div class="owal-alerts__left-align-wrapper">
        <day-collection
          :key="now"
          :date="now"
          :events="[]"
          />
      </div>
    </div>
  </div>
</template>

<script>
import DayCollection from './DayCollection.vue'
import OwalFilterPanel from './OwalFilterPanel'
import moment from 'moment'
import VirtualList from 'vue-virtual-scroll-list'
import { AutoSizingList } from '@/mixins'
import InfiniteLoading from 'vue-infinite-loading'
import OwalSpinnerBanner from '@/libraries/owal-ui/spinners/OwalSpinnerBanner'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'NotificationsTimeline',
  components: {
    DayCollection,
    'virtual-list': VirtualList,
    InfiniteLoading,
    OwalSpinnerBanner,
  },
  mixins: [AutoSizingList],
  data: function () {
    return {
      now: moment.utc().format('MMMM Do, YYYY'),
      OwalFilterPanel,
    }
  },
  computed: {
    ...mapGetters('events', ['filters', 'hasVisibleEvents', 'eventsByDay', 'loading']),
    ...mapGetters({
      hasSingleAlertSource: 'hasSingleAlertSource',
    }),
  },
  methods: {
    ...mapActions('events', ['loadEventsForDomain']),
    loadNewEvents() {
      console.log('LoadEventsForDomain called from objectalerts.vue @infinite')
      this.loadEventsForDomain()
    },
  },
  watch: {
    loading: function () {
      if (this.loading === false && this.$refs.infinite) {
        this.$refs.infinite.stateChanger.loaded()
      }
    },
  },
  created () {
    // console.log('LoadEventsForDomain called from objectalerts.vue created')
    //  this.loadEventsForDomain()
  },
}
</script>

<style scoped>
.owal-alerts__timeline-wrapper {
  height: 100%;
}

.owal-alerts__timeline-wrapper.full-width {
  width: 100%;
}
.owal-alerts__timeline-wrapper.split {
  width: 50%;
}

.owal-alerts__empty-results-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  padding: 2.5rem 1.5rem 0rem 1.5rem;
}

.owal-alerts__left-align-wrapper {
  display: flex;
  flex: initial;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
  width: 68.5714285714rem;
}
.owal-alerts__left-align-wrapper
  >>> .owal.header.banner.container
  .owal.header.banner.primary {
  padding-top: 0.8rem;
  padding-bottom: 0.8rem;
}
</style>

<style>
.infinite-wrapper.split > ul {
  padding-inline-start: 0px;
}
</style>
